import React, { ReactNode } from 'react'
import styled from 'styled-components'
import ModalBase from 'react-modal'

import Hr from 'components/HorizontalRuler'
import Button, { ButtonType } from 'components/Button'

interface Props {
  title: ReactNode
  description?: ReactNode
  warning?: ReactNode
  isOpen: boolean
  closeModal(): void
  confirm(): void
  confirmButtonVariant?: ButtonType
}

const Title = styled.h1`
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
`
const Bold = styled.b`
  display: block;
  margin: 25px 0 20px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
`
const Text = styled.p`
  color: ${({ theme }) => theme.colors.textConfirmation};
  margin-bottom: 30px;
`
const CancelButton = styled(Button)`
  margin-top: 15px;
`
const Modal = styled(ModalBase)`
  background: ${({ theme }) => theme.colors.backgroundDisabled};
  padding: 20px 24px;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.25);
  width: 325px;
  position: absolute;
  left: calc(50% - 325px / 2);
  text-align: center;
  top: 10%;

  :focus {
    outline: unset;
  }
`

export default function ConfirmationDialog({
  title,
  description,
  warning,
  isOpen,
  closeModal,
  confirm,
  confirmButtonVariant = 'main',
}: Props) {
  return (
    <Modal isOpen={isOpen} contentLabel="Confirmation">
      <Title>{title}</Title>
      <Hr />
      {warning && <Bold>{warning}</Bold>}
      {description && <Text>{description}</Text>}
      <Button variant={confirmButtonVariant} onClick={confirm}>
        Submit
      </Button>
      <CancelButton variant="secondary" onClick={closeModal}>
        Cancel
      </CancelButton>
    </Modal>
  )
}
